import { render, staticRenderFns } from "./PageFrame.vue?vue&type=template&id=6916f394&scoped=true&"
import script from "./PageFrame.vue?vue&type=script&lang=js&"
export * from "./PageFrame.vue?vue&type=script&lang=js&"
import style0 from "./PageFrame.vue?vue&type=style&index=0&id=6916f394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916f394",
  null
  
)

export default component.exports